export const MOBILE_BREAKPOINT = 1024;